import { useReducer, useEffect } from 'react';

const initialState = {};

function reducer(state, action) {
  switch (action.type) {
    case 'reset':
      return { range: action.payload, value: action.payload };
    case 'change':
      return { ...state, value: action.payload };
    default:
      return state;
  }
}

/**
 * The state of a RangeSelector
 *
 * @example
 * const state = useRangeSelector()
 * {state.range && <RangeSelector {...range} />}
 */
export function useRangeSelector(source) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (source && !state.range) {
      dispatch({ type: 'reset', payload: source });
    }
  }, [source, state, dispatch]);

  const onChange = value => dispatch({ type: 'change', payload: value });

  return { ...state, onChange };
}
